var _circle, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle2, _circle3, _circle4, _path12, _path13, _path14, _circle5, _circle6, _circle7, _circle8, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForgotLockIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 82,
    viewBox: "0 0 102 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.3696,
    cy: 40.7407,
    r: 40.7407,
    fill: "#EBF1FA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.8887,
    y: 34.8145,
    width: 40,
    height: 28.8889,
    fill: "#B8D7FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7031 63.334H69.629",
    stroke: "#5290DC",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0371 62.9634V32.2227H70.3704V62.9634",
    stroke: "#5290DC",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5918 63.334H82.2214",
    stroke: "#5290DC",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.334 67.7783H31.8525",
    stroke: "#5290DC",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7031 67.7783H43.7031",
    stroke: "#5290DC",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0371 67.4082H72.963",
    stroke: "#5290DC",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.666 31.852V23.3335C37.2833 20.0002 40.7401 13.5557 49.629 14.4446C52.0981 14.5681 57.5549 16.5187 59.629 23.3335V31.852",
    stroke: "#5290DC",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.334 31.8516V20.668C34.1305 16.2917 38.5909 7.83104 50.0604 8.99803C53.2464 9.16011 60.2874 11.721 62.9636 20.668V31.8516",
    stroke: "#5290DC",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8145 63.3341V47.4082",
    stroke: "#5290DC",
    strokeWidth: 1.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4453 43.3336V39.6299",
    stroke: "#5290DC",
    strokeWidth: 1.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8145 32.5928V36.2965",
    stroke: "#5290DC",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.1114,
    cy: 25.9259,
    r: 2.46296,
    stroke: "#5290DC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.96296,
    cy: 14.0743,
    r: 2.46296,
    stroke: "#5290DC"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.2227,
    cy: 25.9259,
    r: 2.46296,
    stroke: "#5290DC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6953 12.4419V11.3755H14.4629V8.58887H15.5483V11.3755H18.3159V12.4419H15.5483V15.2222H14.4629V12.4419H11.6953Z",
    fill: "#5290DC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6953 51.7017V50.6353H94.4629V47.8486H95.5483V50.6353H98.3159V51.7017H95.5483V54.4819H94.4629V51.7017H91.6953Z",
    fill: "#5290DC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6582 36.8862V35.8198H97.4258V33.0332H98.5112V35.8198H101.279V36.8862H98.5112V39.6665H97.4258V36.8862H94.6582Z",
    fill: "#5290DC"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.92535,
    cy: 38.5191,
    r: 1.72222,
    stroke: "#5290DC"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.0738,
    cy: 59.6304,
    r: 1.72222,
    stroke: "#5290DC"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.0738,
    cy: 8.88921,
    r: 1.72222,
    stroke: "#5290DC"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.1485,
    cy: 45.1856,
    r: 2.96296,
    fill: "#5290DC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6658 47.0371L45.5547 53.3334H50.3695L49.2584 47.4075L46.6658 47.0371Z",
    fill: "#5290DC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotLockIcon);
export default __webpack_public_path__ + "static/media/forgotLockIcon.36d6cd84dd80d21b72384ac422c42614.svg";
export { ForwardRef as ReactComponent };